var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAddressDelivery = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 80,
    stroke: "currentColor",
    fill: "currentColor",
    viewBox: "0 0 72 80",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "a",
    width: 72,
    height: 80,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M72 .578H.55v78.844H72V.578Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.554 78.533c19.084 0 34.554-8.523 34.554-19.038 0-10.514-15.47-19.038-34.554-19.038C17.471 40.457 2 48.981 2 59.495 2 70.01 17.47 78.533 36.554 78.533Z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M28.846 48.69c2.55-5.124 5.095-10.25 7.644-15.37 2.743-5.515 5.559-11.38 5.064-17.52-.236-2.946-1.335-5.943-3.579-7.875-1.454-1.253-3.31-1.99-5.21-2.26-4.681-.67-9.536 1.508-12.576 5.118-3.04 3.61-4.364 8.472-4.151 13.18.213 4.71 1.872 9.271 4.216 13.363 2.348 4.091 5.37 7.759 8.592 11.365Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M34.98 6.086a42.672 42.672 0 0 0-2.991-1.6 13.903 13.903 0 0 0-5.71-1.389h-.042a8.02 8.02 0 0 0-3.238.583 19.971 19.971 0 0 0-7.361 5.24 19.658 19.658 0 0 0-4.271 8.052c-.24.941-.356 1.91-.348 2.881.011 2.653.444 5.295 1.354 7.786 2.232 6.12 5.926 11.689 9.95 16.926a9.355 9.355 0 0 0 3.705 2.88l2.785 1.203"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M34.66 24.962c2.024-4.051 1.166-8.576-1.917-10.107-3.083-1.53-7.222.513-9.246 4.564s-1.166 8.576 1.917 10.107c3.083 1.53 7.222-.513 9.246-4.564Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M29.65 14.354c1.168 2.11 1.156 5.163-.252 7.99-1.443 2.885-3.953 4.751-6.398 5.033"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "m28.919 48.486-5.006-1.94-6.793 7.987L2.742 57.34l23.597 13.922 14.375-3.1 10.17-10.567 9.485-.362 9.578-11.057-23.729-13.802-9.694 11.037-4.715-.266-2.89 5.341Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M17.228 54.552 40.65 68.157M30.636 45.374l20.351 12.217M36.605 43.357 60.35 57.194"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAddressDelivery);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/address-delivery.21c32584b14053076f003fd261b259de.svg";